import React from 'react'
import Naslov from '../../components/Naslov/Naslov'
import ZahtjevStatus from '../../containers/ZahtjevStatus/ZahtjevStatus'

const zahtjevStatusLayout = () => {
  return (
    <>
      <Naslov naslov="Provjera statusa predanog zahtjeva" />
      <ZahtjevStatus />
    </>
  )
}

export default zahtjevStatusLayout
